/* ============ AERIS — deplacement du widget d'avis Judge.me ============
   Judge.me rend son widget dans sa propre section, en bas de la page
   (apres le pied de page). On le deplace juste sous la description
   produit, sans toucher a son code : on attend qu'il apparaisse, puis
   on le remonte. Robuste au rendu asynchrone de Judge.me grace a un
   MutationObserver + un filet de securite temporise. */
(function(){
  var desc = document.getElementById('guide-tailles');
  if(!desc) return; /* pas sur une page produit */

  var moved = false;

  function target(){
    /* Le widget d'avis principal de Judge.me. */
    return document.getElementById('judgeme_product_reviews')
        || document.querySelector('.jdgm-review-widget');
  }

  function move(){
    if(moved) return true;
    var w = target();
    if(!w || !desc.parentNode) return false;
    /* On enveloppe pour un espacement propre, puis on insere juste
       apres la description, a l'interieur de la buybox. */
    var wrap = document.createElement('div');
    wrap.className = 'aeris-reviews';
    w.parentNode.removeChild(w);
    wrap.appendChild(w);
    desc.insertAdjacentElement('afterend', wrap);
    moved = true;
    return true;
  }

  if(move()) return;

  /* Judge.me se rend souvent apres le chargement : on observe le DOM. */
  var obs = new MutationObserver(function(){
    if(move()){ obs.disconnect(); }
  });
  obs.observe(document.body, {childList:true, subtree:true});

  /* Filet de securite : on arrete d'observer au bout de 10 s. */
  window.setTimeout(function(){ try{ obs.disconnect(); }catch(e){} }, 10000);
})();
